"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-nested-ternary */
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const Button_1 = require("~/components/UI/Button");
const EditProjectForm_1 = __importDefault(require("~/components/ProjectManagement/EditProjectForm"));
const CloseButton_1 = __importDefault(require("~/components/common/controls/CloseButton"));
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const events_1 = require("~/utils/events");
const utils_1 = require("~/utils/utils");
const routes_1 = require("~/consts/routes");
const useSubmissionGuard_1 = __importDefault(require("~/hooks/useSubmissionGuard"));
const useGuestProjectSave_1 = __importDefault(require("~/hooks/useGuestProjectSave"));
const NewProjectModal_module_scss_1 = __importDefault(require("./NewProjectModal.module.scss"));
function NewProjectModal({ creation = false, closable, cancelHandler = () => {
    // Do nothing
}, }) {
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const createdProject = (0, react_redux_1.useSelector)(selectors_1.selectCreatedProject);
    const currentUserRole = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const currentProject = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const userId = (0, react_redux_1.useSelector)(selectors_1.selectUserId);
    const [project, setProject] = (0, react_1.useState)(null);
    const { isSubmitting, trySubmit } = (0, useSubmissionGuard_1.default)();
    const { dispatchCreateProject, dispatchCreateProjectSuccess, dispatchEditProject, dispatchEditProjectSuccess, dispatchGetCurrentProjectSuccess, dispatchValidateTokenAction, dispatchUpdateProject, } = (0, redux_1.bindActionCreators)({
        dispatchCreateProject: actions_1.createProject,
        dispatchCreateProjectSuccess: actions_1.createProjectSuccess,
        dispatchEditProject: actions_1.editProject,
        dispatchEditProjectSuccess: actions_1.editProjectSuccess,
        dispatchGetCurrentProjectSuccess: actions_1.getCurrentProjectSuccess,
        dispatchValidateTokenAction: actions_1.validateTokenAction,
        dispatchUpdateProject: actions_1.updateProject,
    }, (0, react_redux_1.useDispatch)());
    const { save: saveGuestProject, saving } = (0, useGuestProjectSave_1.default)(currentProject, userId, dispatchUpdateProject, (id) => {
        navigate(`/projects/${id}`);
        (0, events_1.hideModal)();
    });
    (0, react_1.useEffect)(() => {
        if (createdProject) {
            navigate(`/projects/${createdProject.id}`);
            dispatchCreateProjectSuccess(null);
            (0, utils_1.resetScene)();
            (0, events_1.hideModal)();
        }
    }, [createdProject]);
    const onSaveButton = () => {
        trySubmit(() => {
            dispatchValidateTokenAction(() => {
                (0, events_1.hideModal)();
                return navigate(routes_1.ROUTE_LOGIN);
            });
            if (project === null || project === void 0 ? void 0 : project.name) {
                if (creation) {
                    dispatchCreateProject(project);
                }
                else if (currentProject && currentProject.id !== 0) {
                    const updatedProject = Object.assign(Object.assign({}, project), { id: currentProject.id, user_id: userId });
                    if (currentProject.user_id === null) {
                        saveGuestProject(updatedProject);
                        return;
                    }
                    dispatchEditProject(updatedProject);
                    dispatchEditProjectSuccess(false);
                    dispatchGetCurrentProjectSuccess(updatedProject);
                    navigate(`/projects/${updatedProject.id}`);
                    (0, events_1.hideModal)();
                }
            }
        });
    };
    const isSaveDisabled = () => {
        if (saving) {
            return true;
        }
        const isProjectNameAbsent = !(project === null || project === void 0 ? void 0 : project.name);
        if (creation) {
            return isProjectNameAbsent;
        }
        return isProjectNameAbsent || !(currentProject === null || currentProject === void 0 ? void 0 : currentProject.id);
    };
    return (react_1.default.createElement("div", { "data-testid": "new-project-modal", className: NewProjectModal_module_scss_1.default.modal },
        react_1.default.createElement("div", { className: NewProjectModal_module_scss_1.default.headline },
            react_1.default.createElement("div", { className: NewProjectModal_module_scss_1.default.title }, t('new-project-modal.title')),
            closable ? react_1.default.createElement(CloseButton_1.default, { onCLickHandler: cancelHandler }) : null),
        react_1.default.createElement("div", { className: NewProjectModal_module_scss_1.default.subtitle },
            react_1.default.createElement("span", null,
                t('new-project-modal.start-of-subtitle'),
                " "),
            t(`new-project-modal.${currentUserRole}-end-of-subtitle`)),
        react_1.default.createElement("div", { className: NewProjectModal_module_scss_1.default.main },
            react_1.default.createElement(EditProjectForm_1.default, { onChange: setProject, isNew: true })),
        react_1.default.createElement("div", { className: NewProjectModal_module_scss_1.default.saveButton },
            react_1.default.createElement(Button_1.Button, { variant: "primary", wide: true, onClick: onSaveButton, disabled: isSaveDisabled() || isSubmitting }, t('save')))));
}
exports.default = NewProjectModal;
